export const GET_ERRORS = "GET_ERRORS";

export const GET_TRADEUNIONS = "GET_TRADEUNIONS";
export const GET_TRADEUNION = "GET_TRADEUNION";
export const DELETE_TRADEUNION = "DELETE_TRADEUNION";

export const GET_SECTORS = "GET_SECTORS";
export const GET_SECTOR = "GET_SECTOR";
export const DELETE_SECTOR = "DELETE_SECTOR";

export const GET_BRANCHES = "GET_BRANCHES";
export const GET_BRANCH = "GET_BRANCH";
export const DELETE_BRANCH = "DELETE_BRANCH";

export const GET_GRADES = "GET_GRADES";
export const GET_GRADE = "GET_GRADE";
export const DELETE_GRADE = "DELETE_GRADE";

export const GET_SITES = "GET_SITES";
export const GET_SITE = "GET_SITE";
export const DELETE_SITE = "DELETE_SITE";



export const GET_EXCHANGERATES = "GET_EXCHANGERATES";
export const GET_EXCHANGERATE = "GET_EXCHANGERATE";
export const DELETE_EXCHANGERATE = "DELETE_EXCHANGERATE";

export const GET_STOPORDERS = "GET_STOPORDERS";
export const GET_MEMBERS = "GET_MEMBERS";
export const GET_MEMBER = "GET_MEMBER";
export const DELETE_MEMBER = "DELETE_MEMBER";

export const GET_INSTITUTIONS = "GET_INSTITUTIONS";
export const GET_INSTITUTION = "GET_INSTITUTION";
export const GET_MEMBERINSTITUTION = "GET_MEMBERINSTITUTION";
export const DELETE_INSTITUTION = "DELETE_INSTITUTION";

export const GET_BATCHES = "GET_BATCHES";
export const GET_BATCH = "GET_BATCH";
export const DELETE_BATCH = "DELETE_BATCH";

export const GET_RECEIPTS = "GET_RECEIPTS";
export const GET_RECEIPT = "GET_RECEIPT";
export const DELETE_RECEIPT = "DELETE_RECEIPT";

export const GET_BILLS = "GET_BILLS";
export const GET_BILL = "GET_BILL";
export const DELETE_BILL = "DELETE_BILL";

export const SET_CURRENT_USER="SET_CURRENT_USER";
export const GET_USERS = "GET_USERS";
export const GET_ROLES = "GET_ROLES";

